import { Injectable } from '@angular/core';
import { Subject, SubscriptionLike as ISubscription} from 'rxjs';
import { WsService } from './ws.service';
import { SettingsService } from './settings.service';
import { LocaleService } from './../ui/locale.service';
import {CurrentModuleService} from "./common-module.service";
import {environment} from "../../settings/environment";

declare var $: any;

@Injectable({
	providedIn: 'root'
})
export class CacheService {
	bundleFileLoadingComplete: Subject<String> = new Subject<String>();
	settingsServiceInitializeSubscription: ISubscription | null = null;
	private codesAlreadyLoaded: boolean = false;

	constructor(private wsService: WsService,
				private settingsService: SettingsService,
				private localeService: LocaleService,
				private currentModuleService: CurrentModuleService) {
		this.settingsServiceInitializeSubscription = this.settingsService.settingsServiceInitializeSubject.subscribe(data => this.settingsServiceInitializeEvent(data));
	};

	public static readonly MESSAGES_DEFAULT: string = "messages";
	private static readonly DATA_LOCATION: string = "app/data/";
	private static readonly CYCLE_NUETRAL: string = "cycleNeutral/";


	private bundleFileListNeutral: String[] = [
		'cycleNeutral/messages',
		'cycleNeutral/INITIALIZATION',
		'cycleNeutral/FILTER'
	];

	bundleFiles = {};
	dropdowns: any = {};
	errorMessage: string;
	cacheLoaded: boolean = false;
	bundlesCnt: number = 0;

	initialize() {
		this.setupSettings();

	}


	public isCacheLoaded(): boolean {
		return this.cacheLoaded;
	}

	public clearCache() {
		this.bundleFiles = {};
		this.cacheLoaded = false;
	}

	private setupSettings() {
		this.settingsService.initialize(environment);
	}


	private settingsServiceInitializeEvent(data) {
		this.setBundles();

	}
	public getDropdowns(): any {
		return this.dropdowns;
	}

	setBundles(skipProcess: boolean = false) {
		let localeStr = this.localeService.getLocaleStr();
		let localeFileSuffix = "";

		if (localeStr && localeStr === LocaleService.LOCALES.spanish) {
			localeFileSuffix = "_es_ES";
		}

		this.populateBundles(this.bundleFileListNeutral,localeFileSuffix, skipProcess);

	};

	private populateBundles(bundleFileList: String[], localeFileSuffix: string, skipProcess: boolean): void {
		for (let bundleFilePath of bundleFileList) {

			if (bundleFilePath.trim().length != 0) {
				let fileName: string = CacheService.DATA_LOCATION + bundleFilePath.trim() + localeFileSuffix;
				this.wsService.execPublicFile(fileName + ".json").subscribe({
    				next: data => this.setupBundlesSuccess(data, bundleFilePath, bundleFileList.length, skipProcess),
    				error: error => { this.errorMessage = <any>error; }
				});
			}
		}
	}

	private setupBundlesSuccess(data, fileName, bundleTotal: number, skipProcess: boolean) {
		this.getBundles(data, fileName);
		this.bundlesCnt++;
		if (bundleTotal == this.bundlesCnt) {
			this.bundlesCnt = 0;
			if (!skipProcess) {
				this.setupDropdowns();
			}
		}
	};
	setupDropdowns() {
		let localeStr = this.localeService.getLocaleStr();

		if (localeStr && localeStr == LocaleService.LOCALES.spanish) {
			this.wsService.execPublicFile(CacheService.DATA_LOCATION + CacheService.CYCLE_NUETRAL + "dropDowns_es_ES.json")
    			.subscribe({
       				next: data => this.setupDropdownsSuccess(data),
        			error: error => this.errorMessage = <any>error
    			});
		} else {
			this.wsService.execPublicFile(CacheService.DATA_LOCATION + CacheService.CYCLE_NUETRAL + "dropDowns.json")
    			.subscribe({
        			next: data => this.setupDropdownsSuccess(data),
        			error: error => this.errorMessage = <any>error
    			});
		}


	};

	private setupDropdownsSuccess(data) {
		this.dropdowns = this.processDropsdowns(data);
		this.bundleFileLoadingComplete.next("true");
	};

	getLabelFromResource(resource: string, args?: string[]): string {
		let retLabel = resource;

		if (resource && resource.split(":").length == 2) {
			var bundles = this.bundleFiles;
			var bundle = bundles[this.getMessageBundleKey(resource)];
			retLabel = this.getLabelForBundle(bundle, resource, args);

			if (retLabel == resource) {
				// No look-up value found in cycle-specific resource files; check cycleNeutral files.
				bundle = bundles[this.getCycleNeutralBundleKey(resource)];
				retLabel = this.getLabelForBundle(bundle, resource, args)
			}
		}
		else {
			retLabel = "No label sent in";
		}

		return retLabel;
	};

	// Performs look-up in bundle for resource.split(":")[1], and returns the string result if look-up successful;
	// if look-up unsuccessful, returns resource.
	private getLabelForBundle(bundle: any, resource: string, args?: string[]): string {
		let label: string = resource;

		if (bundle) {
			label = bundle[resource.split(":")[1]];
			if (label) {
			//	label = this.replaceGlobalDates(label);
			//	label = this.replaceGlobalForms(label);

				if (args != undefined) {
					let index: number = 0;
					for (let replaceVal of args) {
						label = label.replace("{" + index + "}", replaceVal);
						index++;
					}
				}
			} else {
				console.error("Look-up undefined, resource:  " + resource);
			}
		} else {
		}

		return label;
	}
	/**
	public getExternalLink(key) {
		let retVal: string = null;
		const suffix: string = '_EN'; //(this.localeService.getLocaleStr() == LocaleService.LOCALES.spanish ? '_ES' : '_EN');
		let localExternalLinks: Array<ExternalLink> = new Array<ExternalLink>();
		localExternalLinks = this.externalLinks;
		for (let externalLink of localExternalLinks) {
			if (externalLink.key == key) {
				retVal = externalLink.link;
			} else if (externalLink.key == (key + suffix)) {
				retVal = externalLink.link;
			}
		}
		if (retVal == null) {
			retVal = "Link is not found and in error";
		}

		return retVal;
	};
	**/

	public getDropDownTextFromVal(choiceType, val) {
		if (val == undefined) {
			return "";
		}
		let cleanVal: string = val.trim();
		let found: string = "";
		$.each(this.dropdowns[choiceType]["choices"], function (key, val) {
			if (val.value.trim() == cleanVal) {
				if (val.value.trim().length != 0) {
					found = val.display;
				} else {
					found = ""
				}
			}
		});
		return found;
	}

	public getDropDownTextFromBoolean(choiceType, boolVal) {
		if (boolVal == undefined) {
			return "";
		}
		let found: string = "";
		let boolValStr: string = boolVal.toString();
		$.each(this.dropdowns[choiceType]["choices"], function (key, val) {
			if (boolValStr == val.value) {
				found = val.display;
			}
		});
		return found;
	}

	private processCodes(data) {
		let codes = {};

		let groupCodes: any[] = [];
		let heldType = "-99";

		$.each(data, function (key, val) {
			if (heldType != $.trim(val.type)) {

				if (heldType != "-99") {
					codes[heldType] = {};
					codes[heldType]['groupCodes'] = groupCodes;
				}
				heldType = $.trim(val.type);
				groupCodes = [];
			}
			groupCodes.push({
				"id": val.id,
				"value": val.value,
				"type": val.type,
				"code": val.code,
				"subtype": val.subtype
			});
		});
		if (heldType != "-99") {
			codes[heldType] = {};
			codes[heldType]['groupCodes'] = groupCodes;
		}

		return codes;
	}

	private getBundles(data, bundleFilePath) {
		let heldReference = "-99";
		let bundleFiles = {};
		let bundles: any = null;
		//data = JSON.parse(jsonData);
		for (var key in data) {
			if (heldReference != data[key].reference.trim()) {

				if (heldReference != "-99") {
					bundleFiles[heldReference] = {};
					bundleFiles[heldReference] = bundles;
				}
				heldReference = data[key].reference;
				bundles = {};
			}
			bundles[data[key].key] = data[key].value;
			// If the bundle entry has a link, add it to the array
			if (data[key].link) {
				bundles[data[key].key + 'link'] = data[key].link;
			}
		}

		if (heldReference != "-99") {
			let potentialNewBundlePath: string = this.getNewPathIfMessages(bundleFilePath);
			bundleFiles[potentialNewBundlePath] = {};
			bundleFiles[potentialNewBundlePath] = bundles;
		}

		this.addToBundles(bundleFiles);
	}

	private getNewPathIfMessages(bundleFilePath: string): string {
		let curBundleFilePath: string = bundleFilePath;

		if (bundleFilePath.indexOf(CacheService.MESSAGES_DEFAULT) != -1) {
			let msgIndex: number = bundleFilePath.indexOf("/");
			curBundleFilePath = bundleFilePath.substring(0, msgIndex + 1) + CacheService.MESSAGES_DEFAULT;
		}

		return curBundleFilePath;
	}

	private addToBundles(bundleFiles) {
		for (var fileName in bundleFiles) {
			if (!this.bundleFiles[fileName]) {
				this.bundleFiles[fileName] = {};
			}
			for (var key in bundleFiles[fileName]) {
				this.bundleFiles[fileName][key] = bundleFiles[fileName][key];
			}
		}
	}


	private processDropsdowns(data) {
		let dropDowns = {};

		let choices: any[] = [];
		let heldKey = "-99";

		$.each(data, function (key, val) {
			if (heldKey != $.trim(val.key)) {

				if (heldKey != "-99") {
					dropDowns[heldKey + "Choices"] = {};
					dropDowns[heldKey + "Choices"]['choices'] = choices;
				}
				heldKey = $.trim(val.key);
				choices = [];
			}
			choices.push({"value": val.value, "display": val.label});
		});
		if (heldKey != "-99") {
			dropDowns[heldKey + "Choices"] = {};
			dropDowns[heldKey + "Choices"]['choices'] = choices;
		}

		return dropDowns;
	};


	deepClone(oldArray: Object[]) {
		let newArray: any = [];
		oldArray.forEach((item) => {
			newArray.push($.extend({}, item));
		});
		return newArray;
	}

	public getResource(resourceKey: string): any {
		return this.bundleFiles[resourceKey];
	}

	getRadioVersionOfDropdown(optionsName) {
		let choices: any[] = this.deepClone(this.dropdowns[optionsName].choices);
		choices = choices.splice(1, choices.length);

		return choices;
	}

	getRadioVersionOfDropdownNoDefault(optionsName) {
		let choices: any[] = this.deepClone(this.dropdowns[optionsName].choices);

		return choices;
	}

/**
	getValueByCodeAndType(type, codeVal) {
		let codes = this.codes;
		let codesOfType = codes[type]['groupCodes'];
		let index = 0;
		let CodeObj;
		let result = "";

		for (index = 0; index < codesOfType.length; index++) {
			CodeObj = codesOfType[index];

			if (CodeObj.code == codeVal) {
				result = CodeObj.value;
			}
		}

		return result;
	}

	isCodeInTypeAndSubtype(type, subtype, codeVal) {
		let codes = this.codes;
		let codesOfType = codes[type]['groupCodes'];
		let index = 0;
		let CodeObj;
		let retcode: boolean = false;
		for (index = 0; index < codesOfType.length; index++) {
			CodeObj = codesOfType[index];
			if (CodeObj.subtype == subtype) {
				if (CodeObj.code == codeVal) {
					retcode = true;
				}
			}
		}

		return retcode;
	}
**/

	/**
	 * Given a value for CODE, TYPE, and SUBTYPE, return the VALUE from the CODE table-sortable.
	 * Returns null if not found.

	public getValueFromCodeAndTypeAndSubtype(codeValue, typeValue, subtypeValue): string {
		const codes = this.codes;
		const codesOfType = codes[typeValue]['groupCodes'];
		let index = 0;
		let codeObj;

		for (index = 0; index < codesOfType.length; index++) {
			codeObj = codesOfType[index];

			if (codeObj.subtype == subtypeValue) {
				if (codeObj.code == codeValue) {
					return codeObj.value;
				}
			}
		}
		return null;
	}
	 **/
	private getMessageBundleKey(resource: string): string {
		return this.currentModuleService.getModuleNameWithSlash() + resource.split(":")[0];
	}

	private getCycleNeutralBundleKey(resource: string): string {
		return CurrentModuleService.CURRENT_MODULE_TYPE_NEUTRAL + "/" + resource.split(":")[0];
	}
}
